<img [src]="trackierSource" alt="">
<div class="ilalert">
    <div class="alert alert-server text-center" role="alert">
        <button type="button" class="close" data-dismiss="alert">×</button>
        <p class="mb-0">Get upto 100% Scholarship and prizes worth 10cr* | <strong>9 Days left!</strong>
            <a href="#" class="alertregister">&nbsp;&nbsp;&nbsp;&nbsp;Register Now! &nbsp;<span><img src="assets/img/arrowright.png" alt=""></span></a></p>
    </div>
</div>

<div class="neetJeepage NEETcolor">

    <!-- body section open -->
    <div class="UNFAPP-signlog-full-area">
        <div class="UNFAPP-signlog-frm-wrpbx">
            <div class="UNFAPP-signlog-frmbx">
                <div class="netjee-paynmnt-frmbx">
                    <h3 class="netjee-paynmnt-hdng">
                        <span>Total Payable</span>
                        <span class="price-txtt">Rs 999</span>
                    </h3>
                    <h4 class="UNFAPP-loginvia-subhdng">CHOOSE PAYMENT METHOD</h4>
                    <hr>
                    <!-- <ul class="netjee-paynmnt-list">
                        <li><img src="assets/img/NEET/card-icon.png" alt=""> Debit/Credit card
                            <span class="netjee-rgt-arrow"></span>
                        </li>
                        <li><img src="assets/img/NEET/upi-icon.png" alt=""> UPI
                            <span class="netjee-rgt-arrow"></span>
                        </li>
                        <li><img src="assets/img/NEET/netbank-icon.png" alt=""> Net Banking
                            <span class="netjee-rgt-arrow"></span>
                        </li>
                    </ul> -->


                    <div>
                        <mat-accordion class="payment-method-accrodian">
                        
                        
                            <mat-expansion-panel>
                                <mat-expansion-panel-header>
                                    <mat-panel-title><img src="images/NEET/card-icon.png" alt=""> Debit/Credit card</mat-panel-title>
                                </mat-expansion-panel-header>
                                <mat-panel-description>
                                    <div class="accro-full-area">
                                        <div class="accro-cnt-row btmgap">
                                            <button class="pay-blue-btn" (click) ="razorPayWindow(routeparam)">PAY NOW</button>
                                        </div>
                                       
                                    </div>
                                </mat-panel-description>
                            </mat-expansion-panel>
                            <mat-expansion-panel>
                                <mat-expansion-panel-header>
                                    <mat-panel-title><img src="images/NEET/upi-icon.png" alt=""> UPI</mat-panel-title>
                                </mat-expansion-panel-header>
                                <mat-panel-description>
                                    <div class="accro-full-area">
                                        <div class="accro-cnt-row btmgap">
                                            <button class="pay-blue-btn" (click) ="razorPayWindow(routeparam)">PAY NOW</button>
                                        </div>
                                      
                                    </div>
                                </mat-panel-description>
                            </mat-expansion-panel>
                           <mat-expansion-panel>
                                <mat-expansion-panel-header>
                                    <mat-panel-title><img src="images/NEET/netbank-icon.png" alt=""> Net Banking</mat-panel-title>
                                </mat-expansion-panel-header>
                                <mat-panel-description>
                                    <div class="accro-full-area">
                                        <div class="accro-cnt-row btmgap">
                                            <button class="pay-blue-btn" (click) ="razorPayWindow(routeparam)">PAY NOW</button>
                                        </div>
                                    </div>
                                </mat-panel-description>
                            </mat-expansion-panel>
                            <!-- <mat-expansion-panel>
                            <mat-expansion-panel-header>
                              <mat-panel-title>EMI</mat-panel-title>
                            </mat-expansion-panel-header>
                            <mat-panel-description>
                              <div class="accro-full-area">
                                ;'l;l;'
                              </div>
                            </mat-panel-description>
                          </mat-expansion-panel>-->
                        
                        
                        </mat-accordion>
                    </div>



                </div>
            </div>
        </div>
    </div>
    <!-- body section closed -->


</div>